import triggerPopup from "../components/_trigger-popup";
import "slick-slider";

// Index USTA partner logos carousel
$("#usta-partners-carousel").slick({
    dots: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    draggable: false,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    responsive: [
        {
            breakpoint: 2000,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1700,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1390,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplaySpeed: 1500,
            },
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplaySpeed: 1500,
            },
        },
        {
            breakpoint: 300,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 1500,
            },
        },
    ],
});

/* ============= TRIGGER POPUP ON PAGE LOAD ============= */
// triggerPopup("#cta-modal");
